// @ts-ignore
export default function (value){
    if(!value || !value.nombre || !value.apellidos) return;
    const nombre = value.nombre[0];
    const apellidos = value.apellidos[0];
    return nombre+apellidos;
}